import cookie from 'cookie';
import * as Sentry from '@sentry/browser';
import { init, configureScope } from '@sentry/browser';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/*!***********************************!*\
  !***  @energysavvy/xp-js-logger  ***!
  !***    ./src/Logger.js          ***!
/*!***********************************!*/

var omitMessage = function omitMessage(_ref) {
  var message = _ref.message,
    extra = _objectWithoutProperties(_ref, ['message']);
  return extra;
};
var Logger = function () {
  function Logger(handlers) {
    _classCallCheck(this, Logger);
    this.handlers = [].concat(handlers || []);
  }
  _createClass(Logger, [{
    key: 'addHandler',
    value: function addHandler(handler) {
      this.handlers.push(handler);
    }
  }, {
    key: 'log',
    value: function log(level, message, extra, exception) {
      /*
      For new code making use of this and associated logging functions:
      - level: Should be one of: info, debug, warning, error, critical
      - message: Should be a string message
      - extra (optional): An object containing extra data about the log message
      - exception (optional): An error object which is related to this log message
       For backwards compatability, this method also safely handles a single message
      object with arbitrary keys. This usage pattern should be considered deprecated.
      */
      var messageIsString = typeof message === 'string';
      var record = {
        level: level,
        message: messageIsString ? message : message.message || '',
        exception: messageIsString ? exception : message.exception,
        extra: messageIsString ? extra : omitMessage(message)
      };
      if (record.extra && Object.keys(record.extra).length === 0) {
        // Standardize records to only have truthy extra if there is actually data.
        record.extra = undefined;
      }
      this.handlers.forEach(function (handler) {
        return handler.emit(record);
      });
    }
  }, {
    key: 'debug',
    value: function debug(message, extra, exception) {
      this.log('debug', message, extra, exception);
    }
  }, {
    key: 'info',
    value: function info(message, extra, exception) {
      this.log('info', message, extra, exception);
    }
  }, {
    key: 'warning',
    value: function warning(message, extra, exception) {
      this.log('warning', message, extra, exception);
    }
  }, {
    key: 'error',
    value: function error(message, extra, exception) {
      this.log('error', message, extra, exception);
    }
  }, {
    key: 'critical',
    value: function critical(message, extra, exception) {
      this.log('critical', message, extra, exception);
    }
  }]);
  return Logger;
}();

/*!***********************************!*\
  !***  @energysavvy/xp-js-logger  ***!
  !***    ./src/sentry.js          ***!
/*!***********************************!*/

function initializeGlobalSentry(sentryKey, options) {
  init({
    dsn: sentryKey,
    environment: options.environment
  });
  configureScope(function (scope) {
    scope.setTag('client', options.client);
    scope.setTag('logger', options.appName);
    scope.setExtra('visitor_id', options.visitorId);
  });
  return Sentry;
}
var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/*!*******************************************!*\
  !***  @energysavvy/xp-js-logger          ***!
  !***    ./src/handlers/SentryHandler.js  ***!
/*!*******************************************!*/

var SentryHandler = function () {
  function SentryHandler(sentryHub) {
    _classCallCheck$1(this, SentryHandler);
    this.sentryHub = sentryHub;
  }
  _createClass$1(SentryHandler, [{
    key: 'emit',
    value: function emit(record) {
      var hub = this.sentryHub;
      var shouldAlert = ['info', 'debug', 'warning'].indexOf(record.level) === -1;
      if (!shouldAlert) {
        var data = record.exception ? Object.assign({
          exception: record.exception
        }, record.extra) : record.extra;
        hub.addBreadcrumb({
          level: record.level,
          message: record.message,
          data: data
        });
      } else {
        hub.withScope(function (scope) {
          scope.setLevel(record.level);
          if (record.extra) {
            Object.keys(record.extra).forEach(function (key) {
              scope.setExtra(key, record.extra[key]);
            });
          }
          if (record.exception) {
            scope.setExtra('message', record.message);
            hub.captureException(record.exception);
          } else {
            hub.captureMessage(record.message);
          }
        });
      }
    }
  }]);
  return SentryHandler;
}();
var _createClass$2 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/*!********************************************!*\
  !***  @energysavvy/xp-js-logger           ***!
  !***    ./src/handlers/ConsoleHandler.js  ***!
/*!********************************************!*/

function logFuncForLevel(level) {
  /* eslint-disable no-console */
  return {
    debug: console.log,
    info: console.info,
    warning: console.warn,
    error: console.error,
    critical: console.error
  }[level] || console.log;
}
var ConsoleHandler = function () {
  function ConsoleHandler() {
    _classCallCheck$2(this, ConsoleHandler);
  }
  _createClass$2(ConsoleHandler, [{
    key: 'emit',
    value: function emit(record) {
      var logArgs = [record.message];
      if (record.extra) {
        logArgs.push('\n');
        logArgs.push(record.extra);
      }
      if (record.exception) {
        logArgs.push('\n');
        logArgs.push(record.exception);
      }
      logFuncForLevel(record.level).apply(undefined, logArgs);
    }
  }]);
  return ConsoleHandler;
}();

/*!***********************************!*\
  !***  @energysavvy/xp-js-logger  ***!
  !***    ./src/index.js           ***!
/*!***********************************!*/

function createLogger(owner, appName, options) {
  var visitorId = cookie.parse(document.cookie || '').visitorid || '';
  var combinedOptions = Object.assign({
    visitorId: visitorId,
    owner: owner,
    appName: appName
  }, options);
  return _createLogger(combinedOptions);
}
function _createLogger(options) {
  var logger = new Logger();
  // By putting the console logger before the sentry logger, we ensure that if both are configured,
  // any console logs captured by sentry end up as part of the Sentry event.
  if (options.console) {
    logger.addHandler(new ConsoleHandler());
  }
  if (options.sentryKey) {
    var sentry = initializeGlobalSentry(options.sentryKey, options);
    logger.addHandler(new SentryHandler(sentry.getCurrentHub()));
  }
  return logger;
}
function getRoutingAppOptions() {
  var dataElement = document.getElementById('energysavvy-data');
  var sentryKey = dataElement && dataElement.getAttribute('data-sentry-dsn') || '';
  var environment = dataElement && dataElement.getAttribute('data-environment-name') || '';
  var client = dataElement && dataElement.getAttribute('data-client-name') || '';
  return {
    sentryKey: sentryKey,
    client: client,
    environment: environment,
    console: !sentryKey
  };
}
function createRoutingAppLogger(owner, appName) {
  var options = getRoutingAppOptions();
  var logger = createLogger(owner, appName, options);
  window.XPLogger = window.XPLogger || logger;
  return logger;
}
export default createLogger;
export { getRoutingAppOptions, createRoutingAppLogger };